import { call, put, select, takeLatest } from 'redux-saga/effects';
import { availableLanguagesActions as actions } from '.';
import { selectSalesOrganization } from '../../salesOrganisation/slice/selectors';
import { salesOrganizationActions } from '../../salesOrganisation/slice';
import { selectUserData } from '../../user/slice/selectors';
import { userActions } from '../../user/slice';
import { selectErpSystem } from '../../erpSystem/slice/selectors';
import { AvailableLanguage } from './types';
import { SalesOrganizationState } from '../../salesOrganisation/slice/types';
import { UserType } from '../../user/slice/types';
import { transformDTO } from 'app/features/availableLanguages/slice/utils';
import { getNewShopLanguages, isNewShop } from 'utils/languageUtils';

export function* fetchAvailableLanguages() {
  const { getAvailableLanguagesSuccess, getAvailableLanguagesFail } = actions;
  const user: UserType = yield select(selectUserData);
  const erpSystem: string = yield select(selectErpSystem);

  // the new webshop has no availableLanguages API, use the static mapping instead
  if (isNewShop(user?.loginUrl)) {
    const newShopAvailableLanguages: any = getNewShopLanguages(erpSystem);
    return yield put(getAvailableLanguagesSuccess(newShopAvailableLanguages));
  }

  const { data }: SalesOrganizationState = yield select(
    selectSalesOrganization,
  );
  if (!data) {
    return yield put(
      getAvailableLanguagesFail('sales organizations is missing in the store'),
    );
  }
  const { shop_url, store_id } = data;
  const shopUrlNoSlash = shop_url.substring(0, shop_url.length - 1);
  try {
    const availableLanguagesResponce = yield call(
      fetch,
      `/gasket-configurator/api/availableLanguages?storeUrl=${shopUrlNoSlash}&storeId=${store_id}`,
    );
    if (availableLanguagesResponce.status !== 200) {
      yield put(getAvailableLanguagesFail('failed to fetch'));
    } else {
      const availableLanguages: AvailableLanguage[] =
        yield availableLanguagesResponce.json();

      const availableLanguagesTransformed: any = yield transformDTO(
        availableLanguages,
      );

      yield put(getAvailableLanguagesSuccess(availableLanguagesTransformed));
    }
  } catch (e) {
    yield put(getAvailableLanguagesFail('failed to fetch'));
  }
}

export function* availableLanguagesSaga() {
  yield takeLatest(
    [
      salesOrganizationActions.getSalesOrganizationSuccess.type,
      userActions.getUserSuccess.type,
    ],
    fetchAvailableLanguages,
  );
}
